<template>
  <div class="date-picker">
    <date-pick
      :value="value"
      @input="$emit('input', $event)"
      :hasInputElement="hasInputElement"
    ></date-pick>
  </div>
</template>

<script>
import DatePick from 'vue-date-pick'

// TODO: refactor datepicker to open in popover by default

export default {
  name: 'DatePicker',
  components: {
    DatePick
  },
  props: {
    hasInputElement: { default: false },
    value: {}
  }
}
</script>

<style lang="scss">
@import '~@/styles/_styleConfigurations.scss';

$vdpColor: $brand;
@import 'vue-date-pick/src/vueDatePick.scss';

.date-picker {
  width: min-content;
}

.vdpHeadCell {
  padding: 0.3em 0.5em 1.8em !important;
  border-top: none !important;
  border-bottom: none !important;
  white-space: nowrap;
}
.vdpCell {
  padding: 0.5em 0 !important;
  border-top: none !important;
}
.vdpInnerWrap {
  box-shadow: none !important;
  border: none !important;
}
</style>
